(function (angular) {
  'use strict';

  angular.module('app').config(function ($localStorageProvider) {
    $localStorageProvider.setKeyPrefix('usersComments');
  });
})(angular);
